import { productTypeCharacteristics } from "@/core/utils/product-type-characteristics";
import { slugify } from "./slugify";

export function buildSeries() {
  return Object.entries(productTypeCharacteristics).map(([typeStr, info]) => {
    const key = slugify(info.name);
    return {
      type: Number(typeStr),
      label: info.name,
      longLabel: info.name,
      key,
      color: info.color,
      gradientId: `${key}-gradient`,
      description: info.description,
      hexaColor: info.hexaColor,
    };
  });
}
